import { getAllFilesQuery, getFileIdQuery } from '@/graphl/queries/import'
import { formatDate } from '@/helpers'

const state = {
  listImportFiles: [],
  loading: false,
  idFileRegister: 0,
  metaDataFiles: {},
  statusPending: false
}

const mutations = {
  'TOGGLE_LOADING_IMPORT' (state, payload = false) {
    state.loading = !!payload
  },
  'SET_FILES_LIST_IMPORT' (state, payload) {
    state.listImportFiles = payload
  },
  'SET_ID_FILE_REGISTER' (state, payload) {
    state.idFileRegister = payload
  },
  'SET_METADATA_FILES' (state, payload) {
    state.metaDataFiles = payload
  },
  'TOGGLE_STATUS' (state, payload = false) {
    state.statusPending = !!payload
  },
}

const actions = {
  getAllFiles ({commit}, page, limit, campaignId) {
    commit('TOGGLE_LOADING_IMPORT', true)
    getAllFilesQuery (page, limit, campaignId).then(res => {
      const { collection } = res.data.importFiles
      const { metadata } = res.data.importFiles
      this.importFiles = collection.map((file) => ({
        id: file.id,
        s: file.status,
        status: file.humanizedStatus,
        date: formatDate(file.createdAt),
        provider: file.provider,
        filename: file.filename,
        errorsReturnFilename: file.errorsReturnFilename,
        errorsReturnUrl: file.errorsReturnUrl,
        messages: file.messages,
        peoplePaidCount: file.peoplePaidCount,
        peopleExpiredCount: file.peopleExpiredCount,
        peopleImportedCount: file.peopleImportedCount,
        peopleRegisteredCount: file.peopleRegisteredCount,
        peopleFailAtCreateCount: file.peopleFailAtCreateCount,
        peopleFailAtRegisterCount: file.peopleFailAtRegisterCount,
        peopleRegisteringCount: file.peopleRegisteringCount
      }))
      commit('SET_FILES_LIST_IMPORT', this.importFiles)
      commit('SET_METADATA_FILES', metadata)
      commit('TOGGLE_LOADING_IMPORT', false)
    }).catch(e => {
      this.erros = e
      commit('TOGGLE_LOADING_IMPORT', false)
    })
  },

  getAllStatus ({commit}, page, limit, campaignId) {
    getAllFilesQuery (page, limit, campaignId).then(res => {
      const { collection } = res.data.importFiles
      this.importFiles = collection.map((file) => ({
        id: file.id,
        s: file.status,
        status: file.humanizedStatus,
        date: formatDate(file.createdAt),
        provider: file.provider,
        filename: file.filename,
        messages: file.messages
      }))
      commit('SET_FILES_LIST_IMPORT', this.importFiles)
    }).catch(e => {
      this.erros = e
    })
  },

  getFileId ({commit}, id) {
    getFileIdQuery (id).then(res => {
      const status = res.data.importFile.status
      if (status === 'fail') {
        commit('TOGGLE_STATUS', true)
      } else {
        commit('TOGGLE_STATUS', false)
      }
    }).catch(e => {
      this.erros = e
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
